import controller from './store-features.controller';
import template1 from './templates/store-features.view.html';
import templateAD from './templates/store-features-adaptative.view.html';

let StoreFeaturesComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  //let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
    return template1;
  }
}

export default StoreFeaturesComponent;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/store-features/store-features.component.js
 **/